/* eslint-disable react/no-danger */
import React, { PropTypes, Component } from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import ProviderDialog from 'common/chooseProvider/ProviderDialog';
import { displayProviderDialogSelector } from 'common/selectors/providerSelector';
import authenticationAware from 'webapp/common/authenticationAware';
import {
    createCloseProviderDialogAction
} from 'common/actions/authenticationActions';

import { clearTrackingData } from 'lib/omniture';
// empty the modal's default styles
Modal.defaultStyles = {};

class ProviderModal extends Component {
    constructor(props) {
        super(props);
        this.closeAuthModal = this.closeAuthModal.bind(this);
    }

    closeAuthModal() {
        this.setState({ searchFilter: '' });
        clearTrackingData();
        this.props.dispatch(createCloseProviderDialogAction());
    }

    render() {
        const {
            showProviderDialog,
            providerSelect
        } = this.props;

        const transparentMask = showProviderDialog ? <div className="js-feed-item-mask active" /> : null;
        return (
            <div>
                {transparentMask}
                <Modal isOpen={showProviderDialog} onRequestClose={this.closeAuthModal} overlayClassName="lightbox-container">
                    <article className="lightbox-watch watch-provider-modal js-bloomed">
                        <div className="btn-close icon-font-before icon-close-solid-before" onClick={this.closeAuthModal} />
                        <section className="watchProvider--modal">
                            <ProviderDialog
                                providerSelect={providerSelect}
                                providerClass="watchProvider__scroll"
                            />
                        </section>
                    </article>
                </Modal>
            </div>
        );
    }
}

ProviderModal.propTypes = {
    dispatch: PropTypes.func,
    showProviderDialog: PropTypes.bool,
    providerSelect: PropTypes.func
};

ProviderModal.defaultProps = {
    showProviderDialog: false
};

const mapStateToProps = (state) => {
    const showProviderDialog = displayProviderDialogSelector(state);
    return {
        showProviderDialog
    };
};


export default authenticationAware()(connect(mapStateToProps)(ProviderModal));



// WEBPACK FOOTER //
// ./app/webapp/modal/authn/ProviderModal.js